import { squaresApi } from '../../../api';
import type { Square } from '../../../types';
import type { SquareStateGetter } from '../types';

export const createClearSquare = (get: SquareStateGetter) => {
  return async (boardId: string, row: number, col: number): Promise<Square> => {
    const square = await squaresApi.clear(boardId, row, col);
    await get().fetchSquares(boardId);
    return square;
  };
};
